// Core game constants shared by client and server.

export const DX = [0, 1, 0, -1] as const; // up, right, down, left
export const DY = [-1, 0, 1, 0] as const;
export const DIR_UP = 0;
export const DIR_RIGHT = 1;
export const DIR_DOWN = 2;
export const DIR_LEFT = 3;

/** Simulation tick rate (Hz). Movement uses an accumulator so speed is independent of tick rate. */
export const TICK_RATE = 30;
export const TICK_DT = 1 / TICK_RATE;
/** Network snapshot rate (Hz). */
export const SNAPSHOT_RATE = 15;

/** Base movement speed in cells per second. */
export const BASE_SPEED = 8.5;

/** Owner ids at or above this value are team territories (TEAM_BASE + teamIndex). */
export const TEAM_BASE = 4000;
export const MAX_OWNER = 4096;

export const LANGUAGES = [
  'en', 'ko', 'ja', 'zh-CN', 'zh-TW', 'es', 'pt-BR', 'fr', 'de', 'ru', 'th', 'id',
] as const;
export type Lang = (typeof LANGUAGES)[number];

export const LANGUAGE_NAMES: Record<Lang, string> = {
  en: 'English', ko: '한국어', ja: '日本語', 'zh-CN': '简体中文', 'zh-TW': '繁體中文',
  es: 'Español', 'pt-BR': 'Português (Brasil)', fr: 'Français', de: 'Deutsch',
  ru: 'Русский', th: 'ไทย', id: 'Bahasa Indonesia',
};

export const CONTACT_EMAIL = 'projectteamforyou@gmail.com';

/** Operator details (displayed in the app footer and legal pages, as required for Korean e-commerce). */
export const BUSINESS = {
  name: '프로젝트팀포유',
  nameEn: 'ProjectTeamForYou',
  ceo: '이유상',
  regNo: '495-25-02209',
  mailOrderNo: '제2026-경북봉화-0037호',
  address: '경상북도 봉화군 상운면 예봉로 1166-68',
  phone: '070-7620-7256',
  email: 'projectteamforyou@gmail.com',
  site: 'https://projectteamforyou.com',
} as const;
